//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash'

import { filterData, downloadFile, sortItems } from '../helpers.js'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'
import { setColumnWidths, saveColumnWidths, loadTableSettings, sendTableColumnsWidths } from './TableColumnWidths.js'

import TableSettings from './TableSettings.vue'
import TableAsyncButton from './TableAsyncButton.vue'
import UpdatesManager from '../UpdatesManager.js'

export default {
  components: {
    TableSettings,
    TableAsyncButton
  },
  props: {
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    store: {
      type: Object,
      default: null
    },
    // Local
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    searchColumns: {
      type: Array,
      default: null
    },
    searchFieldAutofocus: {
      type: Boolean,
      default: false
    },
    // Server
    urlBase: {
      type: String,
      default: null
    },
    additionalUrlParams: {
      type: Object,
      default: null
    },
    postRequest: {
      type: Boolean,
      default: false
    },
    dataFieldKey: {
      type: String,
      default: null
    },
    mapper: {
      type: Function,
      default: null
    },
    bodyParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    formId: {
      type: String,
      default: null
    },
    filterType: {
      type: String,
      default: ''
    },
    // ===
    updateEvent: {
      type: String,
      default: ''
    },
    primaryKey: {
      type: String,
      default: 'id'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    singleMultipleCompatible: { // Для таблиц, в которых нужно иметь оба режима, но используется только один вариант слота - для содержимого q-tr
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: null
    },
    selectedItems: {
      type: Array,
      default: null
    },
    selectedItemsIds: {
      type: Array,
      default () {
        return []
      }
    },
    toolbarHidden: {
      type: Boolean,
      default: false
    },
    notConfigurable: {
      type: Boolean,
      default: false
    },
    qTableClass: {
      type: String,
      default: ''
    },
    qTableStyle: {
      type: String,
      default: ''
    },
    trStyleFn: {
      type: Function,
      default () {
        return null
      }
    },
    trClassFn: {
      type: Function,
      default () {
        return null
      }
    },
    autoUpdate: { // Not reactive
      type: Boolean,
      default: true // TODO false
    },
    autoUpdateTimeout: {
      type: Number,
      default: 60000
    },
    profiles: {
      type: Boolean,
      default: true
    },
    profilesHidden: {
      type: Boolean,
      default: false
    },
    updateIntervalTimeout: {
      type: Number,
      default: 60000
    },
    hideBottom: {
      type: Boolean,
      default: false
    },
    enableTopRowSlot: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    hideMultipleControlButtons: {
      type: Boolean,
      default: false
    },
    hideSettings: {
      type: Boolean,
      default: false
    },
    notSelectable: {
      type: Boolean,
      default: false
    },
    allSelectDisabled: {
      type: Boolean,
      default: false
    },
    exportReport: {
      type: Boolean,
      default: false
    },
    exportOptions: {
      type: Array,
      default () {
        return [
          {
            label: 'Выгрузить в Excel'
          }
        ]
      }
    },
    thin: {
      type: Boolean,
      default: false
    },
    narrowScroll: {
      type: Boolean,
      default: false
    },
    visibleColumns: {
      type: Array,
      default () {
        return null
      }
    },
    paginationProp: {
      type: Object,
      default: null
    },
    rowsPerPageOptionsProp: {
      type: Array,
      default: null
    },
    virtualScroll: {
      type: Boolean,
      default: false
    },
    notSaveScroll: {
      type: Boolean,
      default: false
    },
    enableSearchFieldModes: {
      type: Boolean,
      default: false
    },
    grid: {
      type: Boolean,
      default: false
    },
    alwaysShowUnselected: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const isServerStore = !!this.urlBase || (!!this.store && !!this.store.proxy)

    return {
      loading: false,
      loadingFile: false,

      searchFieldText: null,
      searchFieldMode: 'containsAll', // containsAll = "Содержит всё", containsAny = "Содержит любое"

      data: [],
      additionalData: null,

      mainLoading: false,
      pagination: this.paginationProp || {
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 10,
        sortBy: '',
        descending: false
      },

      commonFilterUpdatedEventHandler: null,
      isServerStore: isServerStore,
      updateEventHandler: null,
      updatesManager: new UpdatesManager({
        autoUpdate: this.autoUpdate && isServerStore,
        autoUpdateTimeout: this.autoUpdateTimeout,
        updateFn: (...args) => {
          return this.updateTable(...args)
            .then(() => {
              const { notApplyScrollPosition } = args[0] || {}
              if (!notApplyScrollPosition) {
                this.applyScrollPosition()
              }
              this.applyPaginationPage()
            })
        },
        skipUpdateFn: () => {
          return this.filterIsEmpty || this.loading
        },
        componentName: 'Table',
        listenDocumentVisibility: true
      }),

      displaySelectedRecords: false,
      filterProfiles: [],
      filterIsEmpty: false,
      selectedfilterProfile: null,
      searchWithEmptyFilter: false,
      selectedItemLocal: null,
      formattedColumns: [],
      settingsOpened: false,
      hasNewColumns: false,

      curCol: null,
      curColWidth: null,
      curColNewWidth: null,
      lastCol: null,
      lastColWidth: null,
      lastColNewWidth: null,
      curColPageX: null,
      ignoreNextTableEvent: false,
      mouseMoveListener: null,
      mouseUpListener: null,
      pageReloadOrCloseListener: null
    }
  },
  computed: {
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    rowsPerPageOptions: function () {
      return this.pagination.rowsPerPage == 0 ? [0] : (this.rowsPerPageOptionsProp || [10, 25, 50])
    },
    tableName: function () {
      // TODO: required параметр, чтобы у каждой таблицы был
      // без него сохранение скролла не работает
      const parts = []
      if (this.filterType) {
        parts.push(this.filterType)
      }
      if (this.formId) {
        parts.push(this.formId)
      }
      return parts.length ? parts.join('.') : null
    },
    showMainSelect: function () {
      return !this.store || !this.store.proxy || this.store.proxy.selectAll
    },
    showMainClear: function () {
      return (!this.store || !this.store.proxy || this.store.proxy.clearAll) && !this.selectAll
    },
    configurable: function () {
      return !this.notConfigurable && !!this.tableName
    },
    settingsButtonShown: function () {
      return !this.hideSettings && this.configurable
    },
    multipleControlButtonsShown: function () {
      return !this.hideMultipleControlButtons && this.multiple
    },
    toolbarShown: function () {
      return !this.toolbarHidden && (this.searchFieldShown || this.settingsButtonShown || this.multipleControlButtonsShown || !!this.$slots.actionsRow || !!this.$scopedSlots.actionsRow || !!this.filterProfiles.length)
    },
    searchFieldShown: function () {
      if (this.toolbarHidden) {
        return false
      }
      if (this.isServerStore) {
        return !!(this.store && this.store.proxy && (this.store.proxy.searchParamKey && !this.store.proxy.filterType || this.store.proxy.searchCustom))
      }
      return !!(this.searchColumns && this.searchColumns.length)
    },
    hasServerFilter: function () {
      return this.isServerStore && !!this.filterType
    },
    profilesHiddenLocal: function () {
      return !(!this.toolbarHidden && this.hasServerFilter && !this.profilesHidden)
    },
    selectedItemsIdsLocal: function () {
      return this.selectedItemsIds || []
    },
    selectAll: function () {
      return this.selectedItemsIdsLocal.length === 0 || this.selectedItems && this.selectedItems.filter(sI => !sI._disabled).length === 0
    },
    mainSelectIconName: function () {
      if (this.selectAll) {
        return 'mdi-checkbox-blank-outline'
      } else if (this.selectedItemsIdsLocal.length === this.pagination.rowsNumber) {
        return 'mdi-checkbox-marked'
      } else {
        return 'mdi-minus-box'
      }
    },
    mainSelectTooltipText: function () {
      if (this.selectAll) {
        return 'Выбрать все записи'
      } else {
        return 'Сбросить все выбранные записи'
      }
    },
    filterProfilesNames: function () {
      return this.filterProfiles.map((filter) => {
        return filter.name
      })
    },
    preparedExportOptions: function () {
      if (this.exportReport && this.exportOptions && this.exportOptions.length) {
        return this.prepareExportOptions(this.exportOptions)
      }
      return []
    },
    alwaysShowUnselectedLocal: function () {
      return this.store && this.store.alwaysShowUnselected || this.alwaysShowUnselected
    }
  },
  watch: {
    tableName: {
      handler: function (tableName) {
        console.log('TableName: ' + tableName)
      },
      immediate: true
    },
    data: function () {
      if (this.data.length === 1) {
        this.$emit('stayed-one-row', this.data[0][this.primaryKey])
      }
    },
    items: function () {
      this.onUpdate()
    },
    // 'store._items': function () {
    //   this.onUpdate()
    // },
    displaySelectedRecords: function () {
      this.pagination.page = 1 // при смене режима возвращаемся на 1 страницу
      this.onUpdate()
    },
    selectedItem: function () {
      if (this.displaySelectedRecords) {
        this.onUpdate()
      } else {
        this.updateItemsSelection()
      }
    },
    selectedItemsIdsLocal: function () {
      if (this.displaySelectedRecords) {
        this.onUpdate({ notApplyScrollPosition: true })
      } else {
        this.updateItemsSelection()
      }
    },
    additionalUrlParams: function () {
      this.setPagination(1)
      this.onUpdate()
    },
    searchFieldText: function (value) {
      if (this.store && this.store.proxy) {
        this.store.proxy.searchValue = value
      }
    },
    searchFieldMode: function (value) {
      this.onUpdate()
      localStorage.setItem('searchFieldMode' + this.tableName, value)
    },
    'pagination.rowsPerPage': {
      handler: function (value) {
        sessionStorage.setItem('rowsPerPagePagination' + this.tableName, value)
      }
    },
    'pagination.page': {
      handler: function (value) {
        this.setPaginationPage(value)
      }
    },
    loading: function (value) {
      this.$emit('loading-change', value)
    }
  },
  created: function () {
    this.updateEventHandler = props => {
      this.updateData(props)
      if (!(props && props.saveScroll)) {
        this.setScrollPosition(0)
      }
    }
    EventBus.$on(this.updateEvent, this.updateEventHandler)
    EventBus.$on(this.updateEvent + '-profile', this.updateProfile)
    this.prepareTableColumns()
    // this.searchWithEmptyFilter = localStorage.getItem('searchWithEmptyFilter-' + this.filterType) === 'true'
    this.addGlobalListeners()

    if (this.store && this.store.proxy) {
      this.searchFieldText = this.store.proxy.searchValue || null
    }

    const rowsPerPage = sessionStorage.getItem('rowsPerPagePagination' + this.tableName)
    if (rowsPerPage) {
      this.pagination.rowsPerPage = parseInt(rowsPerPage)
    }

    if (this.enableSearchFieldModes) {
      const searchFieldMode = localStorage.getItem('searchFieldMode' + this.tableName)
      if (searchFieldMode) {
        this.searchFieldMode = searchFieldMode
      } else {
        this.searchFieldMode = 'containsAny'
      }
    }

    if (this.alwaysShowUnselectedLocal) {
      const displaySelectedRecords = localStorage.getItem('displaySelectedRecords' + this.tableName)
      if (displaySelectedRecords != null) {
        this.displaySelectedRecords = JSON.parse(displaySelectedRecords)
      }
    }
  },
  mounted: function () {
    this.updateData()
    if (this.configurable) {
      const tableEl = this.getInnerTableElement()
      if (tableEl) {
        this.updateResizableGrid(tableEl)
      }
    }

    const $scroll = this.getScrollEl()
    if ($scroll) {
      $scroll.onscroll = this.saveScrollPosition
    }
  },
  updated: function () {
    if (this.configurable) {
      const tableEl = this.getInnerTableElement()
      if (tableEl) {
        this.updateResizableGrid(tableEl)
      }
    }

    // Получение текущего профиля фильтрации
    // axiosGet({
    //   url: '/service/delta/dispatcher/getfilter?type=' + this.filterType,
    //   onSuccess: (response) => {
    //     this.selectedfilterProfile = response.data.profile
    //   },
    //   onFailure: 'Ошибка загрузки фильтра',
    //   msgTarget: this
    // })
  },
  activated: function () {
    this.updatesManager.restoreUpdates('componentActivity', true)
  },
  deactivated: function () {
    this.updatesManager.stopUpdates('componentActivity')
  },
  beforeDestroy: function () {
    if (this.$store.getters.getHasNotSentChanges) {
      sendTableColumnsWidths(this.$store, this.tableName).then(response => {
        this.$store.dispatch('setHasNotSentChanges', false)
      })
    }
    this.updatesManager.destroy()
    EventBus.$off(this.updateEvent, this.updateEventHandler)
    EventBus.$off(this.updateEvent + '-profile', this.updateProfile)
    this.removeGlobalListeners()
  },
  methods: {
    /**
     * Настройка таблицы
     */
    updateResizableGrid: function (tableEl) {
      const theadEl = tableEl.getElementsByTagName('thead')[0]
      const trEl = theadEl.getElementsByTagName('tr')[0]
      const cols = trEl ? trEl.children : (theadEl ? theadEl.children : null)
      if (!cols) {
        return
      }

      // tableEl.style.overflow = 'hidden'
      const rowHeight = theadEl.offsetHeight
      for (let i = 0; i < cols.length; i++) {
        const resizableColumn = cols[i].querySelector('.resizable_column')
        if (!resizableColumn && cols[i].__vue__.$vnode.data.key) {
          const div = this.createDiv(rowHeight)
          cols[i].append(div)
          // cols[i].style.position = 'relative'
          this.addColumnListeners(div)
        } else {
          if (resizableColumn && cols[i].__vue__.$vnode.data.key) {
            resizableColumn.style.height = rowHeight == 0 ? 30 + 'px' : rowHeight + 'px'
          }
        }
      }
    },
    getInnerTableElement: function () {
      return this.$el && this.$el.querySelector(':scope > div.q-table__container table.q-table') || null
    },
    createDiv: function (height) {
      const div = document.createElement('div')
      div.className = 'resizable_column'
      div.style.top = 0
      div.style.right = 0
      div.style.width = '5px'
      div.style.position = 'absolute'
      div.style.cursor = 'col-resize'
      div.style.userSelect = 'none'
      div.style.height = height + 'px'
      return div
    },
    addColumnListeners: function (div) {
      div.addEventListener('mousedown', e => {
        this.curCol = e.target.parentElement
        this.curColPageX = e.pageX

        // const padding = this.paddingDiff(this.curCol)

        this.curColWidth = this.curCol.offsetWidth // - padding
        this.lastCol = this.curCol
        while (this.lastCol.nextElementSibling) {
          this.lastCol = this.lastCol.nextElementSibling
        }
        this.lastColWidth = this.lastCol.offsetWidth
      })

      div.addEventListener('mouseover', function (e) {
        e.target.style.borderRight = '2px solid #0000ff'
      })

      div.addEventListener('mouseout', function (e) {
        e.target.style.borderRight = ''
      })
    },
    getNewColumnStylesWhileChangingWidth: function (style, newWidth) {
      let hasOverflowStyle = false
      let hasWhiteSpaceStyle = false
      let hasMinWidthStyle = false
      let hasMaxWidthStyle = false
      const stylesArray = style.split(';')
      stylesArray.forEach((style, i) => {
        if (style.includes('min-width')) {
          stylesArray[i] = `min-width: ${newWidth}px`
          hasMinWidthStyle = true
        }
        if (style.includes('max-width')) {
          stylesArray[i] = `max-width: ${newWidth}px`
          hasMaxWidthStyle = true
        }
        if (style.includes('overflow')) {
          hasOverflowStyle = true
        }
        if (style.includes('white-space')) {
          hasWhiteSpaceStyle = true
        }
      })
      if (!hasOverflowStyle) {
        stylesArray.push('overflow: hidden')
      }
      if (!hasWhiteSpaceStyle) {
        stylesArray.push('white-space: normal')
      }
      if (!hasMinWidthStyle) {
        stylesArray.push(`min-width: ${newWidth}px`)
      }
      if (!hasMaxWidthStyle) {
        stylesArray.push(`max-width: ${newWidth}px`)
      }
      return stylesArray.join('; ')
    },
    addGlobalListeners: function () {
      if (this.configurable) {
        this.pageReloadOrCloseListener = () => {
          if (this.$store.getters.getHasNotSentChanges) {
            sendTableColumnsWidths(this.$store, this.tableName).then(response => {
              this.$store.dispatch('setHasNotSentChanges', false)
            })
          }
        }
        window.addEventListener('beforeunload', this.pageReloadOrCloseListener)

        this.mouseMoveListener = e => {
          if (this.curCol) {
            clearTimeout(this.$store.getters.getChangeWidthTimerID(this.tableName))
            const contentMinPadding = 5
            const diffX = e.pageX - this.curColPageX
            this.curColNewWidth = this.curColWidth + diffX
            let contentMinWidth = null
            const iconEl = this.curCol.getElementsByTagName('i')[0]
            if (iconEl) {
              contentMinWidth = iconEl.offsetWidth + contentMinPadding
            }
            if (contentMinWidth && this.curColNewWidth < contentMinWidth) {
              this.curColNewWidth = contentMinWidth
            }
            this.curCol.style.maxWidth = this.curColNewWidth + 'px'
            this.curCol.style.minWidth = this.curColNewWidth + 'px'
            this.curCol.style.whiteSpace = 'pre-line'
            const columnName = this.curCol.__vue__.$vnode.data.key
            const columnIndex = this.formattedColumns.findIndex(el => el.name === columnName)
            const newValue = this.formattedColumns[columnIndex]

            newValue.style = this.getNewColumnStylesWhileChangingWidth(newValue.style, this.curColNewWidth)
            this.$set(this.formattedColumns, columnIndex, newValue)
            if (this.lastCol.__vue__.$vnode.data.key != this.curCol.__vue__.$vnode.data.key) {
              this.lastColNewWidth = this.lastColWidth - diffX
              this.lastCol.style.maxWidth = this.lastColNewWidth + 'px'
              this.lastCol.style.minWidth = this.lastColNewWidth + 'px'
              const lastColumnName = this.lastCol.__vue__.$vnode.data.key
              const lastColumnIndex = this.formattedColumns.findIndex(el => el.name === lastColumnName)
              const lastColumnNewValue = this.formattedColumns[lastColumnIndex]
              if (lastColumnNewValue) {
                lastColumnNewValue.style = this.getNewColumnStylesWhileChangingWidth(lastColumnNewValue.style, this.lastColNewWidth)
                this.$set(this.formattedColumns, lastColumnIndex, lastColumnNewValue)
              }
            }
          }
        }
        document.addEventListener('mousemove', this.mouseMoveListener)

        this.mouseUpListener = e => {
          if (this.curCol) {
            const columnName = this.curCol.__vue__.$vnode.data.key

            const width = {
              [columnName]: this.curColNewWidth
            }
            setColumnWidths(width, this.tableName, this.$store)
            this.curCol = null
            this.curColWidth = null
            this.curColPageX = null

            const trEl = e.composedPath().find(el => el.className === 'q-tr')
            if (trEl) {
              this.ignoreNextTableEvent = true
            }
          }
          const tableEl = this.getInnerTableElement()
          if (tableEl) {
            this.updateResizableGrid(tableEl)
          }
        }
        document.addEventListener('mouseup', this.mouseUpListener)
      }
    },
    removeGlobalListeners: function () {
      if (this.configurable) {
        document.removeEventListener('mousemove', this.mouseMoveListener)
        document.removeEventListener('mouseup', this.mouseUpListener)
        window.removeEventListener('beforeunload', this.pageReloadOrCloseListener)
      }
    },
    onSaveSettings: function () {
      this.hasNewColumns = false
      this.configureTableColumnsBySettings()
    },
    onCloseSettings: function () {
      this.settingsOpened = false
      this.hasNewColumns = false
    },
    prepareTableColumns: function () {
      if (this.configurable) {
        this.configureTableColumnsBySettings()
      } else {
        this.formattedColumns = this.columns
      }
    },
    configureTableColumnsBySettings: function () {
      this.settingsOpened = false
      this.mainLoading = true
      this.loadTableSettings()
        .then(response => {
          if (!this.$store.getters.getHasNotSentChanges && response.widths) {
            const widths = JSON.parse(response.widths) // может быть "null"
            if (widths) {
              this.$store.dispatch('setColumnWidths', { [this.tableName]: widths })
            }
          }
          if (this.$store.getters.getColumnWidths) {
            response.widths = this.$store.getters.getColumnWidths[this.tableName]
          }
          this.formatTableColumnsBySettings(response)
        })
        .finally(() => {
          this.mainLoading = false
        })
    },
    loadTableSettings: function () {
      return loadTableSettings(this.tableName)
    },
    formatTableColumnsBySettings: function (tableSettings) {
      let columnsWidths
      if (tableSettings && tableSettings.widths) {
        columnsWidths = tableSettings.widths
      } else {
        columnsWidths = {}
      }
      for (const column of this.columns) {
        const columnWidth = columnsWidths[column.name]

        if (columnWidth != null) {
          saveColumnWidths(
            {
              [column.name]: columnWidth
            },
            this.tableName,
            this.$store
          )
        }
        column.headerStyle = this.getNewColumnStylesWhileChangingWidth(column.headerStyle || '', (columnWidth || column.defaultWidth || 200))
        column.style = this.getNewColumnStylesWhileChangingWidth(column.style || '', (columnWidth || column.defaultWidth || 200))
      }

      if (tableSettings && tableSettings.order && tableSettings.hidden) {
        const formattedColumns = []
        const columnsOrder = [...new Set(JSON.parse(tableSettings.order))]
        const hiddenColumns = [...new Set(JSON.parse(tableSettings.hidden))]

        const notFoundColumnsNames = []
        for (const columnName of columnsOrder) {
          if (!hiddenColumns.includes(columnName)) {
            const column = this.columns.find(column => column.name === columnName)
            if (column) {
              formattedColumns.push(column)
            } else {
              notFoundColumnsNames.push(columnName)
            }
          }
        }
        for (const column of this.columns) {
          if (!columnsOrder.includes(column.name)) {
            column.new = true
            this.hasNewColumns = true
          } else {
            column.new = false
          }
        }
        if (notFoundColumnsNames.length) {
          console.log('Columns not found: ' + notFoundColumnsNames.join(','))
        }
        if (formattedColumns.length === 0) {
          this.formattedColumns = this.columns
        } else {
          this.formattedColumns = formattedColumns
        }
      } else {
        this.formattedColumns = this.columns
      }
    },

    /**
     * Получение и выбор элементов
     */
    disableChecked: function (row) {
      if (row._disabled) {
        return true
      }
      const selectedItem = this.selectedItems && this.selectedItems.find(item => item[this.primaryKey] === row[this.primaryKey])
      if (selectedItem && selectedItem._disabled) {
        return true
      }
      return false
    },
    onMainSelect: function () {
      if (!this.allSelectDisabled) {
        if (this.selectAll) {
          this.$emit('select-all-items')
        } else {
          this.$emit('clear-selection')
        }
      }
    },
    onClickItem: function (item) {
      if (this.multiple || this.disableChecked(item)) {
        return
      }

      if (item == null || item[this.primaryKey] === (this.selectedItemLocal && this.selectedItemLocal[this.primaryKey])) {
        this.selectedItemLocal.isChecked = false
        this.selectedItemLocal = null
      } else {
        if (this.selectedItemLocal) {
          this.selectedItemLocal.isChecked = false
        }
        this.selectedItemLocal = item
        this.$set(this.selectedItemLocal, 'isChecked', true)
      }
      this.emitItemSelection(this.selectedItemLocal)
    },
    onCheckItem: function (item, checked) {
      item.isChecked = !!checked
      this.selectedItemLocal = checked ? item : null
      this.emitItemSelection(item) // TODO this.selectedItemLocal
    },
    emitItemSelection: function (item) {
      this.$emit('select-item', item)
    },
    onPageChanged: function (value) {
      if (this.pagination.page !== value) {
        this.pagination.page = value
        this.$emit('update-pagination', value)
        this.onUpdate()
      // .then(() => {
      //   this.$emit('after-page-changed', value)
      // })
      }
    },
    // available from outside
    setPagination: function (value) {
      this.pagination.page = value
    },
    updateData: function (props = {}) {
      if (!this.profilesHiddenLocal) {
        this.getFilterProfiles()
      }
      this.searchWithEmptyFilter = false
      if (!props.savePage) {
        this.pagination.page = 1
      }
      this.onUpdate()
    },
    onSearch: _.throttle(function () {
      const pagination = JSON.parse(JSON.stringify(this.pagination))
      pagination.page = 1

      this.onUpdate({ pagination })
    }, 1500, {
      leading: false
    }),
    onTableRequest: function (props) {
      if (this.ignoreNextTableEvent) {
        this.ignoreNextTableEvent = false
        return
      }

      this.onUpdate(props)
    },
    onUpdate: function (props) {
      return this.updatesManager.onUpdate(props)
    },
    updateTable: async function (props) {
      if (this.displaySelectedRecords && !this.selectedItemsIdsLocal.length && !this.alwaysShowUnselectedLocal) {
        this.pagination.page = 1
        this.data = []

        this.$emit('update-data', {
          data: this.data,
          additionalData: this.additionalData,
          total: 0
        })
        return Promise.resolve()
      }

      const { page, rowsPerPage, sortBy, descending } = props && props.pagination ? props.pagination : this.pagination
      const showLocalSelectedItems = this.displaySelectedRecords && !!(this.isServerStore && !!this.selectedItems)
      if (!this.isServerStore || showLocalSelectedItems) {
        let items
        if (showLocalSelectedItems) {
          items = this.selectedItems
        } else {
          if (this.store) {
            items = await this.store.load(this.searchFieldText)
          } else {
            items = this.items
          }
          if (this.displaySelectedRecords) {
            if (this.alwaysShowUnselectedLocal) {
              const selectedItemsIdsSet = new Set(this.selectedItemsIdsLocal)
              items = items.slice().sort((a, b) => {
                const isASelected = selectedItemsIdsSet.has(a[this.primaryKey])
                const isBSelected = selectedItemsIdsSet.has(b[this.primaryKey])
                if (isASelected !== isBSelected) {
                  return isASelected ? -1 : 1
                } else {
                  return 0
                }
              })
            } else {
              items = items.filter(item => this.selectedItemsIdsLocal.includes(item[this.primaryKey]))
            }
          }
        }
        if (this.searchFieldText && this.searchColumns && this.searchColumns.length) {
          items = filterData(items, this.searchFieldText, this.searchColumns, this.searchFieldMode)
        }

        if (sortBy) {
          const sortByColumn = this.columns.find(column => column.name === sortBy)
          if (sortByColumn && sortByColumn.sort) {
            const fieldName = sortByColumn.field || sortByColumn.name
            items = items.slice().sort((item1, item2) => {
              const val1 = sortByColumn.format ? sortByColumn.format(item1[fieldName]) : item1[fieldName]
              const val2 = sortByColumn.format ? sortByColumn.format(item2[fieldName]) : item2[fieldName]
              const result = sortByColumn.sort(val1, val2, item1, item2, descending)
              return descending ? -result : result
            })
          } else {
            items = sortItems(items.slice(), sortBy, descending)
          }
        }

        const rowsNumber = items.length
        const startIndex = rowsPerPage === 0 ? 0 : (page - 1) * rowsPerPage
        const endIndex = rowsPerPage === 0 ? rowsNumber : Math.min(startIndex + rowsPerPage, rowsNumber)
        this.data = items.slice(startIndex, endIndex)
        this.updateItemsSelection()

        this.pagination.page = page
        this.pagination.rowsPerPage = rowsPerPage
        this.pagination.rowsNumber = rowsNumber
        this.pagination.sortBy = sortBy
        this.pagination.descending = descending

        this.$emit('update-data', {
          data: this.data,
          additionalData: this.additionalData,
          total: items.length
        })
        return Promise.resolve()
      }

      const proxy = this.store ? this.store.proxy : {
        post: !!this.postRequest,
        urlBase: this.urlBase,
        urlParams: this.additionalUrlParams,
        bodyParams: this.bodyParams,
        filterType: this.filterType,
        formId: this.formId,
        mapper: this.mapper,
        searchParamKey: null
      }

      const urlParams = new URLSearchParams()
      if (this.searchWithEmptyFilter) {
        urlParams.append('forceEmptyFilter', 'true')
      }
      if (this.displaySelectedRecords) {
        urlParams.append('ids', this.selectedItemsIdsLocal.join(','))

        // показываем все выбранные записи независимо от фильтра
        if (proxy.filterType) {
          urlParams.append('filter', 'none')
        }
      } else {
        const fetchCount = rowsPerPage === 0 ? this.pagination.rowsNumber : rowsPerPage
        const startIndex = (page - 1) * rowsPerPage

        urlParams.append('limit', fetchCount)
        urlParams.append('start', startIndex)

        if (proxy.filterType) {
          urlParams.append('filter', proxy.filterType)
        }
        if (proxy.formId) {
          urlParams.append('formId', proxy.formId)
        }
      }

      if (sortBy) {
        urlParams.append('sort', sortBy)
        urlParams.append('dir', descending ? 'DESC' : 'ASC')
      }
      if (proxy.urlParams) {
        Object.entries(proxy.urlParams).forEach(([key, value]) => urlParams.append(key, value))
      }
      if ((proxy.searchParams || proxy.searchParamKey) && !proxy.searchCustom && this.searchFieldText) {
        if (proxy.searchParams != null) {
          const params = proxy.searchParams
          params.value = this.searchFieldText
          urlParams.append('params', JSON.stringify([params]))
        } else if (!proxy.filterType) {
          urlParams.append(proxy.searchParamKey, this.searchFieldText)
        }
      }

      const url = proxy.urlBase + //
        (proxy.urlBase.includes('?') ? '&' : '?') + //
        urlParams.toString()

      let bodyFormData = null
      if (proxy.post && proxy.bodyParams) {
        bodyFormData = new FormData()
        for (const [key, value] of Object.entries(proxy.bodyParams)) {
          bodyFormData.set(key, value)
        }
      }

      this.loading = true
      const requestFn = proxy.post ? axiosPost : axiosGet
      return requestFn({
        url: url,
        data: bodyFormData,
        onSuccess: (response) => {
          const { result, total, count, status, filterIsEmpty, ...additionalData } = response.data

          const rowsNumber = total != null ? total : count != null ? count : result ? result.length : response.data.length
          this.filterIsEmpty = !!filterIsEmpty
          this.additionalData = additionalData

          let data = result || response.data[this.dataFieldKey] || response.data || []
          if (proxy.mapper) {
            data = data.map(proxy.mapper)
          }
          this.data = data
          this.updateItemsSelection()
          this.pagination.page = page
          this.pagination.rowsPerPage = rowsPerPage
          this.pagination.rowsNumber = rowsNumber
          this.pagination.sortBy = sortBy
          this.pagination.descending = descending

          this.$emit('update-data', { data, additionalData, total })
        },
        onFailure: 'Ошибка при загрузке данных таблицы',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onSearchWithEmptyFilter: function (value) {
      // localStorage.setItem('searchWithEmptyFilter-' + this.filterType, (value && 'true') || 'false')
      this.searchWithEmptyFilter = value
      if (value) {
        this.onUpdate()
      }
    },
    updateItemsSelection: function () {
      if (this.multiple) {
        this.data.forEach(item => {
          const isChecked = item[this.primaryKey] != null && this.selectedItemsIdsLocal.includes(item[this.primaryKey])
          this.$set(item, 'isChecked', isChecked)
        })
      } else if (!this.notSelectable) {
        this.data.forEach(item => {
          const isChecked = !!this.selectedItem && this.selectedItem[this.primaryKey] === item[this.primaryKey]
          this.$set(item, 'isChecked', isChecked)
          if (isChecked) {
            this.selectedItemLocal = item
          }
        })
      }
    },
    isItemSelected: function (item) {
      if (item && item[this.primaryKey] != null) {
        if (this.multiple) {
          return this.selectedItemsIdsLocal.includes(item[this.primaryKey])
        } else {
          return this.selectedItem && this.selectedItem[this.primaryKey] === item[this.primaryKey]
        }
      }
      return false
    },

    /**
     * Профили фильтрации
     */
    updateProfile: function (profile) {
      if (profile === '$user_custom') {
        profile = 'Пользовательский'
      }
      this.selectedfilterProfile = profile
    },
    applyFilterProfile: function (filterProfile) {
      if (filterProfile === 'Пользовательский') {
        filterProfile = '$user_custom'
      }
      const url = '/service/delta/dispatcher/setcurrentfilterprofile' +
                  '?type=' + this.filterType +
                  '&name=' + filterProfile +
                  (this.formId ? `&formId=${this.formId}` : '')
      axiosGet({
        url: url,
        onSuccess: () => {
          EventBus.$emit('update-server-filter', {})
          EventBus.$emit(this.updateEvent)
        },
        onFailure: 'Ошибка применения профиля фильтрации',
        msgTarget: this
      })
    },
    getFilterProfiles: function () {
      const url = '/service/delta/dispatcher/getfilterprofiles' +
                  '?type=' + this.filterType +
                  (this.formId ? `&formId=${this.formId}` : '')
      axiosGet({
        url: url,
        onSuccess: response => {
          this.filterProfiles = response.data
        },
        onFailure: 'Ошибка получения профилей фильтрации',
        msgTarget: this
      })
    },
    selectFilterProfile: function (filterName) {
      this.selectedfilterProfile = filterName
      this.applyFilterProfile(filterName)
    },

    /**
     * Выгрузка отчёта
     */
    onClickDownloadTable: function (e) {
      /***
       * Triggering the tooltip to hide,
       * because the button goes into disabled mode when this.loadingFile === true
       * and does not emit native events by itself
       * */
      e.target.dispatchEvent(new MouseEvent('mouseleave', {
        view: window,
        bubbles: true,
        cancelable: true
      }))
      this.onDownloadTable(this.exportOptions[0])
    },
    onDownloadTable: function (option = null) {
      this.loadingFile = true

      let url
      if (option && option.gridTemplatedXlsReport) {
        url = '/service/delta/reportSource/gridTemplatedXlsReport'
      } else {
        url = '/service/delta/reportSource/filteredTableExport/xlsx'
      }

      const bodyFormData = new FormData()
      if (!(option && option.ignorePrefix)) {
        const prefix = `delta-table-config.${this.tableName || this.filterType}`
        bodyFormData.set('prefix', prefix)
      }

      if (option && option.includeFilter) {
        bodyFormData.set('filter', this.filterType)
      }

      const reportKey = option && option.reportKey || `${this.filterType}ExportReport`
      bodyFormData.set('reportKey', reportKey)

      // В режиме "Выбранные записи" выгружаются только выбранные
      if (this.selectedItemsIdsLocal.length && this.displaySelectedRecords) {
        bodyFormData.set('ids', this.selectedItemsIdsLocal)
      }
      if (this.formId) {
        bodyFormData.set('formId', this.formId)
      }
      if (this.pagination && this.pagination.sortBy) {
        bodyFormData.set('sort', this.pagination.sortBy)
      }
      if (this.pagination && this.pagination.descending) {
        bodyFormData.set('dir', this.pagination.descending ? 'DESC' : 'ASC')
      }
      if (option && option.props) {
        bodyFormData.set('props', JSON.stringify(option.props))
      }

      return downloadFile(url, () => {
        this.loadingFile = false
      }, this, 'POST', bodyFormData)
    },

    getDownloadTableReportKey: function (exportOption) {
      return exportOption && exportOption.reportKey || `${this.filterType}ExportReport`
    },

    prepareExportOptions: function (options) {
      const newOptions = JSON.parse(JSON.stringify(options))
      return newOptions.map(option => {
        if (option && !option.gridTemplatedXlsReport) {
          option.format = 'xlsx'
          option.type = 'filteredTableExport'
        } else {
          option.type = 'gridTemplatedXlsReport'
        }

        option.formDataProps = {}

        if (!(option && option.ignorePrefix)) {
          const prefix = `delta-table-config.${this.tableName || this.filterType}`
          option.formDataProps.prefix = prefix
        }

        if (option && option.includeFilter) {
          option.formDataProps.filter = this.filterType
        }

        option.reportKey = this.getDownloadTableReportKey(option)

        // В режиме "Выбранные записи" выгружаются только выбранные
        if (this.selectedItemsIdsLocal.length && this.displaySelectedRecords) {
          option.formDataProps.ids = this.selectedItemsIdsLocal
        }
        if (this.formId) {
          option.formDataProps.formId = this.formId
        }
        if (this.pagination && this.pagination.sortBy) {
          option.formDataProps.sort = this.pagination.sortBy
        }
        if (this.pagination && this.pagination.descending) {
          option.formDataProps.dir = this.pagination.descending ? 'DESC' : 'ASC'
        }
        if (option && option.props) {
          option.formDataProps.props = JSON.stringify(option.props)
        }
        return option
      })
    },

    /**
     * Сохранение позиции скролла
     */
    getScrollEl: function () {
      if (this.tableName) {
        const $mainDiv = document.getElementById('table_component_' + this.tableName)
        if ($mainDiv) {
          const scrolls = $mainDiv.getElementsByClassName('q-table__middle')
          if (scrolls && scrolls.length !== 0) {
            return scrolls[0]
          }
          return null
        }
      }
      return null
    },
    saveScrollPosition: function () {
      let value = null
      const $scroll = this.getScrollEl()
      if ($scroll) {
        value = $scroll.scrollTop
      }

      if (value != null) {
        this.setScrollPosition(value)
      }
    },
    setScrollPosition: function (value) {
      localStorage.setItem('scrollTop' + this.tableName, value)
    },
    applyScrollPosition: function () {
      let scrollTop = 0

      if (!this.notSaveScroll) {
        const scrollTopStr = localStorage.getItem('scrollTop' + this.tableName)
        if (scrollTopStr && !isNaN(scrollTopStr)) {
          scrollTop = Number(scrollTopStr)
        }
      }

      const $scroll = this.getScrollEl()
      if ($scroll) {
        const maxScrollTop = $scroll.scrollHeight - $scroll.clientHeight
        if (scrollTop < maxScrollTop) {
          $scroll.scrollTop = scrollTop
        }
      }
    },
    setPaginationPage: function (value) {
      if (this.tableName) {
        sessionStorage.setItem('paginationPage_' + this.tableName, value)
      }
    },
    applyPaginationPage: function () {
      if (this.tableName) {
        const pageStr = sessionStorage.getItem('paginationPage_' + this.tableName)
        if (pageStr && !isNaN(pageStr)) {
          const page = Number(pageStr)
          const pagesAmount = this.pagination.rowsPerPage && Math.ceil(this.pagination.rowsNumber / this.pagination.rowsPerPage)
          if (page > 0) {
            if (pagesAmount && page > pagesAmount) {
              this.pagination.page = pagesAmount
            } else {
              this.pagination.page = page
            }
          }
        }
      }
    },
    setDisplaySelectedRecords: function (value) {
      this.displaySelectedRecords = value
      if (this.alwaysShowUnselectedLocal) {
        localStorage.setItem('displaySelectedRecords' + this.tableName, value)
      }
    }
  }
}
